import React, {FC, useState} from 'react';
import {Table, Button, Modal} from 'antd';
import {ColumnProps} from 'antd/lib/table';
import {QuestionCircleFilled} from '@ant-design/icons';
import {red} from '@ant-design/colors';
import {css} from '@emotion/core';

interface Row {
  produit: string;
  matiere: string;
  profondeurDansLeConduit: string;
  evide: string;
  maintien: string;
  confort: string;
  discretion: string;
  attenuation: string;
  poignee: string;
  isRed?: boolean;
}

const columns: ColumnProps<Row>[] = [
  {title: 'Produit', key: 'produit', render: (data: Row) => data.produit},
  {title: 'Matière', key: 'matiere', render: (data: Row) => data.matiere},
  {
    title: 'Profondeur dans le conduit',
    key: 'profondeurDansLeConduit',
    render: (data: Row) => data.profondeurDansLeConduit,
  },
  {title: 'Evidé', key: 'evide', render: (data: Row) => data.evide},
  {title: 'Maintien', key: 'maintien', render: (data: Row) => data.maintien},
  {title: 'Confort', key: 'confort', render: (data: Row) => data.confort},
  {
    title: 'Discrétion',
    key: 'discretion',
    render: (data: Row) => data.discretion,
  },
  {
    title: 'Atténuation',
    key: 'attenuation',
    render: (data: Row) => data.attenuation,
  },
  {title: 'Poignée', key: 'poignee', render: (data: Row) => data.poignee},
];

const dataSource: Row[] = [
  {
    produit: 'Sweetnight Conque court plein*',
    matiere: 'Silicone 25 Sh',
    profondeurDansLeConduit: 'Court',
    evide: 'Non',
    maintien: '* * * * *',
    confort: '* * *',
    discretion: '* * *',
    attenuation: '* * * *',
    poignee: 'Non',
    isRed: true,
  },
  {
    produit: 'Sweetnight Conque long évidé',
    matiere: 'Silicone 25 Sh',
    profondeurDansLeConduit: 'Long',
    evide: 'Oui',
    maintien: '* * * * *',
    confort: '* * * *',
    discretion: '* * *',
    attenuation: '* * * *',
    poignee: 'Non',
  },
  {
    produit: 'Sweetnight Conque long plein',
    matiere: 'Silicone 25 Sh',
    profondeurDansLeConduit: 'Long',
    evide: 'Non',
    maintien: '* * * * *',
    confort: '* * *',
    discretion: '* * *',
    attenuation: '* * * * *',
    poignee: 'Non',
  },
  {
    produit: 'Sweetnight Conque court évidé',
    matiere: 'Silicone 25 Sh',
    profondeurDansLeConduit: 'Court',
    evide: 'Oui',
    maintien: '* * * * *',
    confort: '* * * * *',
    discretion: '* * *',
    attenuation: '* * *',
    poignee: 'Non',
  },
  {
    produit: 'Sweetnight Canule long évidé*',
    matiere: 'Silicone 25 Sh',
    profondeurDansLeConduit: 'Long',
    evide: 'Oui',
    maintien: '* * * *',
    confort: '* * * *',
    discretion: '* * * * *',
    attenuation: '* * *',
    poignee: 'Oui',
    isRed: true,
  },
  {
    produit: 'Sweetnight Canule long plein',
    matiere: 'Silicone 25 Sh',
    profondeurDansLeConduit: 'Long',
    evide: 'Non',
    maintien: '* * * *',
    confort: '* * * *',
    discretion: '* * * * *',
    attenuation: '* * * *',
    poignee: 'Oui',
  },
];

const tableCss = css`
  .ant-table-red-row {
    color: ${red[6]};
  }
`;

export const SweetNightOptionsTable: FC = () => {
  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      rowClassName={(record) => (record.isRed ? 'ant-table-red-row' : '')}
      css={tableCss}
      pagination={false}
    />
  );
};

export const SweetNightHelp: FC = () => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Button
        onClick={() => setVisible(true)}
        style={{padding: '4px 8px', marginLeft: 8}}
      >
        <QuestionCircleFilled />
      </Button>
      <Modal
        visible={visible}
        onCancel={() => setVisible(false)}
        onOk={() => setVisible(false)}
        width="80%"
        title="Options SweetNight"
        cancelButtonProps={{style: {display: 'none'}}}
      >
        <SweetNightOptionsTable />
      </Modal>
    </>
  );
};
